export default __webpack_public_path__ + "static/media/IMG-20240822-WA0014.3f6bf322.jpg";